import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, ViewChild, Inject, ElementRef, Renderer2 } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwComponentSectionConfigPreference, DwMdFormContextInfo, DwFormContextMode } from '@devwareapps/devware-cap';
import * as FilePond from 'filepond';
import { flatMap, combineLatest, map, last } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';

import { ConfigService } from "src/environments/environment";
import { FileControlNewConfig } from "../models/file-control-new-config.model";
import { FileControlNewConfigComponent } from "./file-control-new-config/file-control-new-config.component";
import { WachterUserExt } from "src/app/shared/models/wachter-user.model";
import { AppMetaDataService } from "src/app/meta-data/app-meta-data.service";
import { any, AnyFalsy } from "underscore";
import { Xmb } from "@angular/compiler";
import { fileURLToPath } from "url";

@DwComponent({
    name: 'New FileControl',
    isGlobal: true,
    componentType: DwComponentType.formSection,
    configComponent : FileControlNewConfigComponent
})

@Component({
    selector: 'app-file-control-new',
    templateUrl: './file-control-new.component.html',
    styleUrls: ['./file-control-new.component.scss']
})
export class FileControlNewComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<FileControlNewConfig>>

implements OnInit {

    private httpClient : HttpClient;
    wAppsApiUrl: string;
    FileControlNewConfig : FileControlNewConfig;
    bearerToken: string;
    pondFiles : any = [];

    @ViewChild('myPond') myPond: FilePond.FilePond;
    @ViewChild('fileDiv') myPondElement : ElementRef;

    trustUserId: number = this.getTrustUserId();

    folderId: number = null;

    fileResource = "api/v3/file";
    folderResource = "api/v3/folder";

    pondOptions = {
        allowDownloadByUrl: true,
        multiple: true,
        labelIdle: 'Click to add files or Drop files here',
        allowRemove: false,
        allowRevert: false,
        computable: false,
        server: {
            process: '',
            fetch: null,
            revert: '',
            load: '',
            headers: { contentTypeOverride: 'multipart/form-data' },
        }
    }

    constructor(private renderer:Renderer2,
        dwExpressionService: DwExpressionService,
        dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private securityService: DwSecurityUserService,
        @Inject(DwSecurityRepositoryServiceToken) private securityRepository: DwSecurityRepositoryService,
        private messageService: DwMessagingService,
        private http: HttpClient,
        private handler: HttpBackend) {
            super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
            this.httpClient = new HttpClient(handler);
    }
    async ngOnInit() {
        super.ngOnInit();
        
        this.wAppsApiUrl = ConfigService.config.wAppsApi;
        this.FileControlNewConfig = this.sectionConfig.config;

        this.setPondOptions();

        const fileObservable : Observable<any> = this.getFiles();
        fileObservable.subscribe(fileResults => {
            fileResults.forEach(files => {
               files.forEach(file => {
                   const responseDetails : Observable<any> = this.http.get(this.wAppsApiUrl + this.fileResource +"?fileId="+file.AttachmentFileId +"&Details=true");
                   responseDetails.subscribe(fileData => {
                       var blob: BlobPart[] = [];
                       blob.push(this.base64toBlob(fileData.Base64, fileData.FileType));
                       var realFile = new File(blob, fileData.FileName);
                       this.myPond.addFile(fileData.FileId,{type: 'local', file: realFile});
                   },
                   (error) => {
                       console.log(error);
                   });

               });
            });
        });
    }

    pondHandleInit(){
    }

    pondHandleAddFile(event: any)
    {
    }

    pondHandleRemoveFile(event: any)
    {
        if (!isNaN(event.file.source) && !isNaN(event.file.source - 0)) {
            this.http.delete(this.wAppsApiUrl + this.fileResource + '?trustUserId=' + this.trustUserId + '&fileId=' + event.file.source).subscribe(
                () => {
                    //this deletes the file;
                },
                error => {
                }
            );
        }
    }

    setPondOptions(){
        const formContext: DwMdFormContextInfo = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
        const canRevert = formContext.contextMode != DwFormContextMode.view;
        this.setFolderId().subscribe(result =>
            {

                this.pondOptions = {
                allowDownloadByUrl: true,
                multiple: true,
                labelIdle: 'Click to add files or Drop files here',
                allowRemove: canRevert,
                allowRevert: canRevert,
                computable: false,
                server:
                {
                    process: this.wAppsApiUrl + this.fileResource +'?trustUserId=' + this.trustUserId + '&folderId=' + result,
                    fetch: null,
                    revert: ConfigService.config.wAppsApi + this.fileResource +'?TrustId=' +  + this.trustUserId,
                    load: ConfigService.config.wAppsApi + this.fileResource +'?json=',
                    headers: { contentTypeOverride: 'multipart/form-data' },
                }
            }
        });
    }

    getTrustUserId() {
        const wachterUser = new WachterUserExt(this.securityService.securityContext.AuthenticatedUser);

        return wachterUser.trustUserId;
    }

    setFolderId()
    {
        const metaData = new AppMetaDataService();
        const queryHelper = new DwQueryHelper();

        const attachmentObjectQuery = metaData.AttachmentObject.CreateQuery();

        const attachmentObjectId = this.getAttributeValue(this.FileControlNewConfig.attachmentId);
        var folderId = new Subject<number>();
        if(attachmentObjectId)
        {
            attachmentObjectQuery.AddFilterAnd(queryHelper.filters.Equal(metaData.AttachmentObject.AttachmentObjectId, attachmentObjectId));

            this.dataService.executeQuerySingle(attachmentObjectQuery).subscribe(results  =>
                {
                    var anyResults = results as any;
                    folderId.next(anyResults.ParentAttachmentFolderId);
                },
                error => {
                    console.log(error);
                });
            return folderId.asObservable();
        }
        else
        {
            var folderInfo = {
                FolderName: 'PF',
                TrustUserId : this.trustUserId,
                PermissionNeeded : null
            };
            this.http.post(this.wAppsApiUrl + this.folderResource +'?createObjectRecord=true',folderInfo).subscribe(
                result=> {
                    if(result)
                    {
                        var folder = result as any;
                        const control = this.getOrCreateFormControl(this.FileControlNewConfig.attachmentId);
                        control.setValue(folder);
                        folderId.next(folder);
                    }
                },
                error => {
                    console.log(error);
                }
            );
            return folderId.asObservable();
        }
    }

    private getFiles() 
    {
        const metaData = new AppMetaDataService();
        const queryHelper = new DwQueryHelper();

        const attachmentObjectQuery = metaData.AttachmentObject.CreateQuery();
        const attachmentFileQuery = metaData.AttachmentAttachmentFile.CreateQuery();

        const attachmentObjectId = this.getAttributeValue(this.FileControlNewConfig.attachmentId);
        if(!attachmentObjectId)
        {
            return of([]);
        }
        attachmentObjectQuery.AddFilterAnd(queryHelper.filters.Equal(metaData.AttachmentObject.AttachmentObjectId, attachmentObjectId));
        const attachmentObjectObservable : Observable<any> = this.dataService.executeQuerySingle(attachmentObjectQuery);
        var attachmentFileResults = attachmentObjectObservable.pipe(
            map(function(attachmentObjectResults){
                attachmentFileQuery.AddFilterAnd(queryHelper.filters.Equal(metaData.AttachmentAttachmentFile.AttachmentFolderId, attachmentObjectResults.ParentAttachmentFolderId));
                attachmentFileQuery.AddFilterAnd(queryHelper.filters.Equal(metaData.AttachmentAttachmentFile.IsDeleted, false));
                return attachmentFileQuery;
            })
        );
        return attachmentFileResults.pipe(map(query => this.dataService.executeQuery(query)));

    }

    getAttributeValue(attrName: string)
    {
        const control = this.getOrCreateFormControl(attrName);

        if(!control) {
            console.warn(`Attribute ${attrName} was not found in the form group!`);
            return `${attrName} not found`;
        }

        return control.value;
    }

    delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);
      
        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);
      
            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
}